import Button from "@metacrm/metacrm-material-ui/dist/Button";
import { Box } from "@mui/material";
import React from "react";
import { StyledSkeleton } from "./WidgetPreview.styles";
import { useFetchEntityConfig } from "features/metadesk/redux/hooks";
import { defaultThemeConfig } from "features/configure";
import { get } from "lodash";
import { useOutletContext } from "react-router";

export default function EmailPreview({ formData, disabled }) {
  const {
    title,
    content,
    image,
    buttonText,
    buttonUrl,
    sendTime,
    emailSetting,
  } = formData;
  const {
    companyAddress = "",
    privacyPolicyLink = "",
    emailAddress = "",
    websiteURL = "",
    socialMediaLink = "",
  } = emailSetting;

  function handleUrl() {
    if (!buttonUrl) return;
    window.open(buttonUrl, "_blank", "noopener noreferrer");
  }
  const { entityConfig } = useFetchEntityConfig();
  const companyLogo = get(entityConfig, "company.logo");
  const [entityName] = useOutletContext();

  const noLink =
    !companyAddress &&
    !privacyPolicyLink &&
    !emailAddress &&
    !websiteURL &&
    !socialMediaLink;

  return (
    <Box
      bgcolor="#EDEDED"
      p="25.5px 16px 0"
      minHeight="639px"
      sx={{ opacity: disabled ? 0.5 : 1 }}
    >
      <Box
        width="100%"
        height="100%"
        bgcolor="#FFFFFF"
        p="36px"
        minHeight="639px"
      >
        <Box
          component={"img"}
          width="auto"
          height="24px"
          src={companyLogo ? companyLogo : defaultThemeConfig.headerLogo}
        />
        <Box bgcolor={"#CBD5E1"} width="100%" height="0.85px" my="36px" />
        {title ? (
          <Box mb="20px" fontSize="20px" fontWeight="700" color="#121A26">
            {title}
          </Box>
        ) : (
          <StyledSkeleton width="221px" mb="20px" />
        )}

        {image && (
          <Box
            component="img"
            mb="20px"
            width="100%"
            sx={{ objectFit: "cover" }}
            height="auto"
            src={image}
          />
        )}
        {content ? (
          <Box
            mb="34px"
            fontSize={14}
            color="#555"
            sx={{ wordBreak: "break-all" }}
          >
            {content}
          </Box>
        ) : (
          <Box mb="34px">
            <StyledSkeleton light mb="12px" />
            <StyledSkeleton light mb="12px" />
            <StyledSkeleton light mb="12px" />
          </Box>
        )}
        {buttonText && (
          <Button onClick={handleUrl} mb="92px">
            {buttonText}
          </Button>
        )}
        <div className="email-container">
          <div className="footer">
            <p className="footer-brand-title">{entityName}</p>
            <Box className="footer-text item-flex" justifyContent="center">
              If you'd rather not receive this email,{" "}
              <Box
                component="span"
                sx={{ textDecoration: "underline", ml: "2px" }}
              >
                unsubscribe
              </Box>
              .
            </Box>
            <div className={noLink ? "" : "footer-text footer-link"}>
              {privacyPolicyLink && (
                <a
                  className="border-right"
                  style={{ textDecoration: "underline" }}
                  href={privacyPolicyLink}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Privacy Policy
                </a>
              )}
              {websiteURL && (
                <a
                  className="border-right"
                  style={{ textDecoration: "underline" }}
                  href={websiteURL}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Official Website
                </a>
              )}
              {socialMediaLink && (
                <a
                  className="border-right"
                  style={{ textDecoration: "underline" }}
                  href={socialMediaLink}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Social Media
                </a>
              )}
              {emailAddress && (
                <a
                  href={`mailto:${emailAddress}`}
                  style={{ textDecoration: "underline" }}
                >
                  Contact Us
                </a>
              )}
              <Box>
                {companyAddress && (
                  <div style={{ textDecoration: "underline" }}>
                    {companyAddress}
                  </div>
                )}
              </Box>
            </div>
            <hr className="footer-divider" />

            <img
              className="footer-logo"
              src={require("assets/img/email-footer-logo.png")}
              alt="Powered by MetaCRM"
              style={{ height: "16px" }}
            />
          </div>
        </div>
      </Box>
    </Box>
  );
}
